export const defaultInitialRegion = { name: 'France', code: 'FR' }
